import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";

import Footer from "./Footer";
import Header from "./Header";



const Layout = ({ children }) => {

 



  return (
    <div className="min-h-screen flex flex-col">
    <section className="sticky top-0 z-[80] ">
<Header/>
    </section>

      {/* MAIN CONTENT */}
      <main className="flex-1 bg-gradient-to-br from-pink-50 via-white to-pink-50 p-6">
        {children}
      </main>

     <Footer/>

      <style>
        {`
          .nav-item {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 10px 14px;
            border-radius: 999px;
            color: #db2777;
            font-weight: 500;
            transition: none;
          }
          .mobile-item {
            display: block;
            padding: 12px 0;
            color: #db2777;
          }
          .mobile-login {
            display: block;
            margin-top: 10px;
            padding: 12px;
            text-align: center;
            background: #db2777;
            color: white;
            border-radius: 999px;
          }
        `}
      </style>
    </div>
  );
};

export default Layout;
